<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-chart-radar`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.74707 0.335135C7.93609 0.257258 8.15307 0.270477 8.33301 0.374198L14.4395 3.90056C14.645 4.01931 14.7723 4.2384 14.7725 4.47576V11.5275C14.7724 11.7649 14.645 11.984 14.4395 12.1027L8.33301 15.6291C8.12736 15.7477 7.8736 15.7477 7.66797 15.6291L1.56152 12.1027C1.3561 11.9839 1.22862 11.7648 1.22852 11.5275V4.47576C1.22866 4.23845 1.35606 4.01933 1.56152 3.90056L7.66797 0.374198L7.74707 0.335135ZM3.22461 11.5265L7.33594 13.9006V9.15349L3.22461 11.5265ZM8.66602 13.8996L12.7773 11.5265L8.66602 9.15252V13.8996ZM2.55859 10.3762L6.67188 8.00115L2.55859 5.62615V10.3762ZM9.33008 8.00115L13.4424 10.3742V5.6281L9.33008 8.00115ZM8.66602 6.84978L12.7783 4.47576L8.66602 2.10174V6.84978ZM3.22363 4.47478L7.33594 6.84881V2.10076L3.22363 4.47478Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineChartRadar',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
